import {Component, Injector} from "@angular/core";
import {AppComponentBase} from "../../../services/AppComponentBase";
import {NgbActiveModal, NgbModal, NgbModalRef} from "@ng-bootstrap/ng-bootstrap";
import {ProvidersList, Providers} from "../../../enums/providers";
import {OpenLiveAccountModal} from "../open-live-account/open-live-account.component";


@Component({
    selector: "mobile-open-live-account",
    template: require('./mobile-open-live-account.component.html'),
    styles: [require('./mobile-open-live-account.component.css')]
})

export class OpenLiveAccountMobileModal extends OpenLiveAccountModal  {
	constructor(
      
        public _activeModal: NgbActiveModal,
        
        injector: Injector,
      //  public orderDeleteData:deleteOrderRequest
    ) {

        super(_activeModal, injector)
    }
}

export function ShowOpenLiveAccountMobileModal(modalService: NgbModal){
    let m:NgbModalRef= modalService.open(OpenLiveAccountMobileModal,{
        backdrop: "static",
        size: "sm",
        centered: true, 
        windowClass: "dark-modal mobile"
    });
    let modal = (<OpenLiveAccountMobileModal>m.componentInstance);
    
    return modal

}
